import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import Login from '../../modules/users/login';
import ResetPassword from '../../modules/users/resetpassword';
import Forgotpassword from '../../modules/users/forgotpassword';
import Menubar from '../menubar/menubar';
import ForgotPasswordScreen from '../../modules/users/forgotpwdscreen';
import SuperAdminPayments from '../../modules/payments/view/superadminpayment';
import ItecPayments from '../../modules/payments/view/itecpayment';
import CoreEMDashboard from '../../modules/newEMDashboard';
import OpenServicePopUp from '../../modules/services/Popup';
import ClientCheckListGenetator from '../../modules/checkListGenerator/clientchecklist/generalinfo/generalinfo';
import AddAdditional from '../../modules/checkListGenerator/addAdditional/index';
import TermsCondition from '../../components/table/termsCondition';

function Routes() {
    return (
        <Router>
            <Switch>
                <Route exact path="/">
                    <Redirect to="/login" />
                </Route>
                <Route excat path="/login" component={Login} />
                <Route path="/forgotpassword" component={Forgotpassword} />
                <Route path="/loginresetpassword" component={ForgotPasswordScreen} />
                <Route path="/reset" component={ResetPassword} />
                <Route path="/menu" component={Menubar} />
                <Route path="/coredashboard" component={CoreEMDashboard} />
                <Route path="/openPopup" component={OpenServicePopUp} />
                <Route path="/termscondition" component={TermsCondition} />
                <Route path="/addAdditional" component={AddAdditional} />
                <Route path="/paymenthistory" component={SuperAdminPayments} />
                <Route path="/itecpayments" component={ItecPayments} />
            </Switch>
        </Router>
    );
}

export default Routes;
